/**
 * @generated SignedSource<<54abc60eb135ceb435db66f485f961b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnenrollClientInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type EnrollmentCardUnenrollMutation$variables = {
  input: UnenrollClientInput;
};
export type EnrollmentCardUnenrollMutation$data = {
  readonly unenrollClient: {
    readonly client: {
      readonly " $fragmentSpreads": FragmentRefs<"ClientAddableItem_client">;
    };
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type EnrollmentCardUnenrollMutation = {
  response: EnrollmentCardUnenrollMutation$data;
  variables: EnrollmentCardUnenrollMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnrollmentCardUnenrollMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnenrollClientPayload",
        "kind": "LinkedField",
        "name": "unenrollClient",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ClientAddableItem_client"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnrollmentCardUnenrollMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnenrollClientPayload",
        "kind": "LinkedField",
        "name": "unenrollClient",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoURL",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bb7691d8786147cdd1872130c8c6392d",
    "id": null,
    "metadata": {},
    "name": "EnrollmentCardUnenrollMutation",
    "operationKind": "mutation",
    "text": "mutation EnrollmentCardUnenrollMutation(\n  $input: UnenrollClientInput!\n) {\n  unenrollClient(input: $input) {\n    clientMutationId\n    client {\n      ...ClientAddableItem_client\n      id\n    }\n  }\n}\n\nfragment ClientAddableItem_client on User {\n  id\n  email\n  displayName\n  photoURL\n}\n"
  }
};
})();

(node as any).hash = "dc7275d358a2435d194f86b8da1b737b";

export default node;
